import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Create a single reusable instance for the whole app
export const appInsights = new ApplicationInsights({
  config: {
    connectionString:
      "InstrumentationKey=60525131-f691-4572-8019-e7857f0225ed;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=02ea856f-d84a-4d8b-8970-97a02266348e",
    enableAutoRouteTracking: false, // We will manually track pages
  }
});

// Initialize App Insights
appInsights.loadAppInsights();
